import React from 'react';

export const Footer = () => (
  <div className="bg-[#F3F4F8] w-full py-12 md:py-14 lg:py-[4.5rem] px-4 md:px-6 lg:flex lg:items-center lg:justify-center">
    <div className="max-w-3xl mx-auto md:text-center md:max-w-2xl">
      <h2 className="text-[#373945] text-3xl md:text-4xl font-semibold lg:text-center mb-4">
        Your guide to lifetime mortgages
      </h2>

      <p className="text-[#373945] text-base font-450 mb-8">
        Download our guide to learn more about the advantages and disadvantages of equity release, where to find independent
        advice, and the next stages in your journey should you choose to proceed.
      </p>

      <a
        href="https://puremediastorage.blob.core.windows.net/pure-web-media/general_process/what-is-er-brochure.pdf"
        target="_blank"
        rel="noopener noreferrer nofollow"
        className="block md:inline-block primary-magenta-large text-center w-full md:w-auto"
      >
        Download guide
      </a>
    </div>
  </div>
);
